import BoxFormView from "./BoxFormView";

function BoxForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  return (
    <BoxFormView
      setPrinterData={setPrinterData}
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      submitError={submitError}
    />
  );
}

export default BoxForm;
